export const ResetPasswordTestIDs = {
  emailInput: "register-email-input",
  passwordInput: "register-password-input",
  passwordConfirmInput: "register-password-confirm-input",
};
